import { getResolvedType } from './Types';
import { ExprError } from './Expr/ExprError';
const createError = (meta, message) => new ExprError.InvalidArgument(meta.name, meta.signature, message, meta.location);
export function validateArguments(signature, args) {
    const errors = [];
    if (signature.arguments.length !== args.length) {
        const _orMore = signature.meta.variadic ? ' or more' : '';
        return [
            createError(signature.meta, `function expected ${signature.arguments.length}${_orMore} ` +
                `arguments but received ${args.length}`),
        ];
    }
    const argumentMapping = args.map((arg, index) => {
        const expected = signature.arguments[index];
        let constraint;
        if (typeof expected === 'string') {
            constraint = { type: expected };
        }
        else {
            constraint = expected;
        }
        const expectedType = constraint.type;
        const actualType = getResolvedType(arg);
        const validStages = constraint.stages;
        const actualStage = arg.stage;
        const customValidation = constraint.customValidation;
        return {
            expectedType,
            actualType,
            validStages,
            actualStage,
            customValidation,
            arg,
        };
    });
    const typeErrors = validateTypeSignature(signature.meta, argumentMapping.map((item) => item.expectedType), argumentMapping.map((item) => item.actualType));
    const stageErrors = validateStage(signature.meta, argumentMapping.map((item) => item.validStages), argumentMapping.map((item) => item.actualStage));
    const customValidationErrors = argumentMapping.reduce((errors, item) => {
        var _a;
        if (item.customValidation) {
            return errors.concat((_a = item.customValidation(item.arg)) !== null && _a !== void 0 ? _a : []);
        }
        return errors;
    }, []);
    return errors
        .concat(typeErrors)
        .concat(stageErrors)
        .concat(customValidationErrors);
}
export const validateTypeSignature = (meta, expectedTypes, actualTypes) => {
    const expected = [];
    const actual = [];
    expectedTypes.forEach((expectedType, index) => {
        const actualType = actualTypes[index];
        let safeActualType = actualType;
        if (expectedType === "NUMERIC") {
            safeActualType = castToNumeric(actualType);
        }
        else if (expectedType === undefined) {
            expectedType = actualType;
        }
        expected.push(expectedType);
        actual.push(safeActualType);
    });
    const expectedSignature = `${expected.join(', ')}`;
    const invokedSignature = `${actual.join(', ')}`;
    if (expectedSignature !== invokedSignature) {
        return [
            createError(meta, `function expected input of (${expectedSignature}) but received (${invokedSignature})`),
        ];
    }
    return [];
};
const castToNumeric = (t) => {
    switch (t) {
        case "INTEGER":
        case "FLOAT":
        case "DECIMAL":
            return "NUMERIC";
        default:
            return t;
    }
};
export const validateStage = (meta, validStageSets, actualStages) => {
    const errors = [];
    validStageSets.forEach((validStages, index) => {
        const actualStage = actualStages[index];
        if (!validStages)
            return;
        if (validStages.length === 0)
            return;
        if (validStages.indexOf(actualStage) === -1) {
            errors.push(createError(meta, `expects argument ${index + 1} to belong to one of the following stages: ` +
                `{ ${validStages.join(', ')} } ` +
                `but received: ${actualStage}`));
        }
    });
    return errors;
};
